var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('AudioIcon'),_c('div',{staticClass:"wrapper"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"button",on:{"click":_vm.onForward}},[_vm._v(_vm._s(_vm.buttonText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }